var React = require('react');

function Send2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1351_796)","key":0},React.createElement("path",{"d":"M0.272524 19.0873C0.108182 19.8425 0.688 20.1622 1.226 19.921L19.4091 10.5973H19.411C19.6279 10.475 19.7538 10.2545 19.7538 10.0002C19.7538 9.74578 19.6279 9.52519 19.411 9.40291H19.4091L1.226 0.0790996C0.688 -0.16215 0.108182 0.157638 0.272524 0.91287C0.283645 0.964026 1.35861 5.75239 1.94308 8.3566L11.435 10.0002L1.94308 11.6435C1.35861 14.2476 0.283596 19.0361 0.272524 19.0873Z","fill":"#04B3C0"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1351_796"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

Send2.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Send2;

Send2.default = Send2;
